<template>
  <validation-provider v-slot="{ errors }" :name="label" :rules="rulesComputed" :debounce="debounce">
    <v-autocomplete
      class="select-multiple-input"
      v-model="model"
      :label="fullLabel"
      :items="itemsComputed"
      :item-text="itemText"
      :item-value="itemValue"
      chips
      small-chips
      deletable-chips
      outlined
      dense
      hide-details="auto"
      hide-no-data
      :clearable="clearable"
      clear-icon="mdi-close"
      :filter="customFilter"
      :error-messages="errors"
      :loading="loading"
      :disabled="disabled"
      @change="onChange"
      multiple
    ></v-autocomplete>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'SelectMultipleInput',

  components: { ValidationProvider },

  props: {
    label: {
      type: String,
      rquired: true,
    },
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemText: {
      type: String,
      required: false,
      default: '',
    },
    itemValue: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    debounce: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    fullLabel() {
      return this.required ? `${this.label}  ${this.$t('ELE0024')}` : this.label
    },
    itemsComputed() {
      return this.items
    },
    rulesComputed() {
      if (this.rules && this.required) {
        return `required|${this.rules}`
      } else if (this.required) {
        return 'required'
      } else if (this.rules) {
        return this.rules
      } else {
        return ''
      }
    },
  },

  methods: {
    customFilter(item, queryText) {
      // 入力されたテキストでプルダウン候補絞り込み (ID,Nameで部分一致検索)
      const id = item[this.itemValue].toLocaleLowerCase()
      const name = item[this.itemText].toLocaleLowerCase()
      const query = queryText.toLocaleLowerCase()
      return id.indexOf(query) > -1 || name.indexOf(query) > -1
    },
    onChange() {
      this.$emit('change')
    },
  },
}
</script>
<style>
/** 背景色指定 */
.select-multiple-input:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #edeffd;
  margin-bottom: 2px;
}
/** ボーダー色指定 */
.select-multiple-input:not(.v-input--is-disabled) > .v-input__control > .v-input__slot > fieldset {
  border-style: solid;
  border-width: 2px;
  border-color: var(--v-primary-base);
}
/* 非活性のラベル色 */
.select-multiple-input.v-input--is-disabled > .v-input__control > .v-input__slot > .v-select__slot > .v-label {
  color: #000000;
}
/* フォーカスが外れている場合のラベル色 */
.select-multiple-input:not(.v-input--is-disabled) > .v-input__control > .v-input__slot > .v-select__slot > .v-label {
  color: var(--v-primary-base);
}
/* 非活性の選択値のフォント色 */
.select-multiple-input.v-input--is-disabled
  > .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-select__selections
  .v-chip {
  background-color: #232323;
  color: #ffffff;
}
/** ラベルとchipが被るのを回避 */
.select-multiple-input > .v-input__control .v-select__selections {
  padding-top: 10px !important;
}
/** エラーメッセージの上端が欠けるのを回避 */
.select-multiple-input > .v-input__control .v-messages {
  margin-top: 1px;
}
/** ローディングの表示位置調整(dense利用時にはあった方がよい) */
.select-multiple-input .v-progress-linear {
  margin-top: 1px;
}
</style>
